import { useEffect, useRef, useState } from 'preact/hooks';

export default function Header({ freeTextSearch, setFreeTextSearch }) {
	const [searchBarClass, setSearchBarClass] = useState('relative');
	const searchBarRef = useRef();
	const [scrollTop, setScrollTop] = useState(0);
	const [offsetTop, setOffsetTop] = useState(0);

	useEffect(() => {
		setOffsetTop(searchBarRef.current.offsetTop);
	}, []);

	useEffect(() => {
		const onScroll = () => {
			setScrollTop(
				window.pageYOffset || document.documentElement.scrollTop
			);
		};
		window.addEventListener('scroll', onScroll);
	}, [scrollTop]);

	useEffect(() => {
		const fixSearchBarOnScroll = offsetTop => {
			if (scrollTop > offsetTop) {
				setSearchBarClass('fixed top-0 z-50');
			} else {
				setSearchBarClass('relative');
			}
		};
		window.addEventListener('scroll', fixSearchBarOnScroll(offsetTop));
	}, [scrollTop]);

	return (
		<div class="bg-light-turquoise pt-3 md:pt-10 md:pb-6 h-32 md:h-60 lg:h-auto lg:pt-14 lg:pb-11">
			<div class="h-full flex flex-col">
				<div class="container">
					<h1 class="text-4xl font-bold lg:text-5xl">Oppslagsverk</h1>
					<p class="text-xl hidden md:block mt-2 lg:mt-5">
						Få innsikt og oversikt over sjømatnæringen.
					</p>
				</div>

				<div
					ref={searchBarRef}
					class={`lg:max-w-container lg:mx-auto w-full bg-light-turquoise mt-auto p-4 lg:mt-3 lg:z-0 lg:relative ${searchBarClass}`}
				>
					<div class="flex w-full lg:max-w-xl relative">
						<input
							type="text"
							class="flex-grow py-2.5 px-3.5 text-base md:text-lg md:py-3 md:px-4 lg:py-4 lg:px-5 appearance-none bg-white placeholder-muted rounded-lg border-2 border-white focus:outline-none focus:border-muted"
							placeholder="Søk i oppslagsverket..."
							onChange={e => setFreeTextSearch(e.target.value)}
							onKeyPress={e => {
								if (e.key === 'Enter') {
									setFreeTextSearch(freeTextSearch);
								}
							}}
							value={freeTextSearch}
						/>
						<button
							class="px-5 absolute top-0 right-0 h-full"
							onClick={() => setFreeTextSearch(freeTextSearch)}
						>
							<i class="far fa-search"></i>
						</button>
					</div>
				</div>
			</div>
		</div>
	);
}
